<template>
  <div>
    <div class="modal fade in show modal-active modal-open" id="archiveProductModal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Archive product</h4>
            <button type="button" class="close" v-on:click="closeModal()">&times;</button>
          </div>
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                Are you sure you want to archive and hide product?
              </div>
            </div>
          </div><!-- Modal body end -->
          <div class="modal-footer mt-2">
            <button type="button" class="btn btn-lg btn-outline-primary mt-2" v-on:click="closeModal()">Cancel</button>
            <button type="button" class="btn btn-lg btn-primary mt-2" v-on:click="archiveProduct()">Archive product</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop show"></div>
  </div>  
</template>

<script>
export default {
  name: "ArchiveProductModal",
  data(){
    return {
    }
  },
  methods: {
    closeModal(){
      this.$emit('closeArchiveProductModal');
    },
    archiveProduct(){
      this.$emit('archiveProduct');
    }
  }
}
</script>